import { Component, Input, OnInit } from '@angular/core';
import { OrganisationService } from './organisation.service';
import { Subscription, combineLatest, map, mergeMap } from 'rxjs';
import { Globals } from '../shared/globals';
import { environment } from 'src/environments/environment';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { SideNavbarService } from '../side-navbar/side-navbar.service';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'organisation',
  templateUrl: './organisation.component.html',
  styleUrls: ['./organisation.component.css']
})
export class OrganisationComponent implements OnInit {

  organisation: any;
  organisations: any;
  isLoaded = false;
  @Input() children: any;
  @Input('unit') id: any;
  orgId: any;
  organisationUnit: any = environment.frontPageOrganisationIndex;
  @Input('education-type-id') educationTypeId: any;
  @Input(':organisation-unit-id') organisationUnitId!: any;
  period: any;
  frontPageRoute: any = environment.frontPageRoute;
  header: any;
  parent: any;
  params: any;
  profileName: any = environment.profileName;
  organisationViewType: any;


  // subscriptions
  private subscription: Subscription = new Subscription();


  constructor(
    public globals: Globals,
    private route: ActivatedRoute,
    private router: Router,
    private navigationService: SideNavbarService,
    private titleService: Title,
    private service: OrganisationService
  ) {
    //console.log('konstruktio')
    /*this.subscription.add(combineLatest([this.route.paramMap, this.route.queryParamMap]).pipe(
      map(params => ({
        id: params[0].get('education-type-id'), 
        period: params[1].get('period')
      })),
      mergeMap((params) => {
          this.id = params.id;
          this.period = params.period;
          //this.id == null ? this.service.getOrganisations(): this.service.getSubOrganisations(this.id);
          return this.navigationService.getNavigationItem((this.id));     
      })
    ).subscribe(value => {
      if(this.orgId == null) {this.header = value.name.valueFi} else {this.header = value.name}
      this.header = value.name;
      //this.parent = value;
      this.educationType = this.parent.id;
      this.setCurrentUrl();
      //this.setTitle();
    }));*/
    const lastUrlSegment = this.router.url.split('?')[0].split('/').pop();
    if(lastUrlSegment === 'o' || lastUrlSegment === 'e') {
        this.organisationViewType = lastUrlSegment;
    }

      this.subscription.add(this.router.events.subscribe((e: any) => {
        // If it is a NavigationEnd event re-initalise the component
        if (e instanceof NavigationEnd) {
          this.initialiseInvites();
        }
      }));
   }

   initialiseInvites() {
    // Set default values and re-fetch any data you need.
    // tällä saadaan aikaan latauspalkki
    this.subscription.add(this.route.url.subscribe(url => {
      this.isLoaded = false;
    }));
    this.ngOnInit();
    //this.getParent();
  }


  ngOnInit(): void {
    //console.log('alustetaan organisation unit: ' + this.organisationUnitId)
    
    //console.log('init')
    this.subscription.add(combineLatest([this.route.paramMap, this.route.queryParamMap]).pipe(
      map(params => ({
        id: params[0].get('organisation-unit-id'), 
        id2: params[0].get('education-type-id'), 
        period: params[1].get('period')
      })),
      mergeMap((params) => {
          //this.id = params.id;
          this.organisationUnitId = params.id;
          this.educationTypeId = params.id2;
          this.period = params.period;
          return this.organisationUnitId == null ? this.service.getOrganisations() : this.service.getOrganisation(this.organisationUnitId);     
      })).subscribe(value => {
        //console.log(value);
    if (this.organisationUnitId == null) {
      this.organisations = value; 
    } else {
      this.organisation = value;
    }
      //this.globals.sortByName2(this.organisations, this.globals.lang);
      
      //console.log('jegba')
      //console.log(this.organisation)
      // jos valikkorakenteessa organisaatio, niin haetaan pelkkä organisaatio eikä piitata poluista
    if (this.educationTypeId) {
      this.getParent();
    } else {
      //console.log('debuggi')
      this.titleService.setTitle(this.globals.getLocalizedValue(this.organisation.name) + environment.titleExtension);
      this.setCurrentUrl()
    }
    }));
    
    //this.getOrganisations();
    //jos uniarts, niin jätetään hakematta
    //console.log(this.educationTypeId);

    

    this.subscription.add(this.globals.setLangFromRoute(this.route));
    this.isLoaded = true;
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }


  getOrganisations() {
    //console.log('tultiin virheellisesti tänne')
    if(this.organisationUnit != undefined) {
      //console.log('haettiin organisaatiota: ' + this.organisationUnit)
      this.subscription.add(this.service.getSubOrganisations(this.organisationUnit).subscribe((value => {
        this.organisations = value;
        this.globals.sortByName2(this.organisations, this.globals.lang);
        //this.getParent();
        this.isLoaded = true;
      })));
    } else {
      //console.log('tän tultiin')
      //console.log(this.organisations)
    }

    /*this.subscription.add(combineLatest([this.route.paramMap, this.route.queryParamMap]).pipe(
      map(params => ({
        id: params[0].get('organisation-unit-id'), 
        period: params[1].get('period')
      })),
      mergeMap((params) => {
          this.id = params.id;
          this.period = params.period;
          return this.service.getOrganisations();     
      })
    ).subscribe(value => {
      this.organisations = value;
      this.globals.sortByName2(this.organisations, this.globals.lang);
      this.isLoaded = true;
    }));*/

   /* if(this.organisationUnit == undefined) {
      this.subscription.add(this.service.getOrganisations().subscribe(
        value => {
          this.organisations = value;
          this.globals.sortByName2(this.organisations, this.globals.lang);
          this.isLoaded = true;
        }
      ));
    }*/
  }

  /**
   * Palauttaa sivua vastaavan koulutustyypin tiedot sivun otsikkoa
   * varten (parent), sekä puurakenteen linkityksiä varten (educationType)
   */
   getParent() {
    this.subscription.add(combineLatest([this.route.paramMap, this.route.queryParamMap]).pipe(
      map(params => ({
        id: params[0].get('education-type-id'), 
        period: params[1].get('period')
      })),
      mergeMap((params) => {
          this.id = params.id;
          this.period = params.period;
          return this.navigationService.getNavigationItem((this.id));     
      })
    ).subscribe(value => {
      this.header = value.name;
      this.parent = value;
      this.educationTypeId = this.parent.id;
      this.setCurrentUrl();
      this.setTitle();
    }));
  }

  setTitle() {

    if(!this.organisation) {
      //jos ei organisaatiota ole määritelty, niin titleen pelkkä koulutustyyppi
      if (this.period) {
        this.titleService.setTitle(this.globals.getLocalizedValue(this.parent.name) + environment.titleExtension + ' ' + this.period);
      } else {
        this.titleService.setTitle(this.globals.getLocalizedValue(this.parent.name) + environment.titleExtension);
      }

    } else {

      if (this.period) {
        this.titleService.setTitle(this.globals.getLocalizedValue(this.parent.name) + ' | ' + this.globals.getLocalizedValue(this.organisation.name) + environment.titleExtension + ' ' + this.period);
      } else {
        this.titleService.setTitle(this.globals.getLocalizedValue(this.parent.name) + ' | ' + this.globals.getLocalizedValue(this.organisation.name) + environment.titleExtension);
      } 
    }
  }

  setCurrentUrl() {
    //console.log('alustusyritys url')
    if (this.parent) {
      //console.log(this.parent.name.valueFi);
      
      //console.log(this.organisation);
      if(!this.organisation) {
        
        if(!this.period) {
            this.globals.currentUrl = {
              valueFi: '/fi/' + this.globals.toKebabCase(this.parent.name.valueFi) + '/' + this.educationTypeId + '/o', 
              valueEn: '/en/' + this.globals.toKebabCase(this.parent.name.valueEn) + '/' + this.educationTypeId + '/o',
              valueSv: '/sv/' + this.globals.toKebabCase(this.parent.name.valueEn) + '/' + this.educationTypeId + '/o'
            };
        } else {
            this.globals.currentUrl = {
              valueFi: '/fi/' + this.globals.toKebabCase(this.parent.name.valueFi) + '/' + this.educationTypeId + '/o' + '?period=' + this.period, 
              valueEn: '/en/' + this.globals.toKebabCase(this.parent.name.valueEn) + '/' + this.educationTypeId + '/o' + '?period=' + this.period,
              valueSv: '/sv/' + this.globals.toKebabCase(this.parent.name.valueEn) + '/' + this.educationTypeId + '/o' + '?period=' + this.period
            };
        }
      
      } else {
        
        //organisaatio löytyy
        this.globals.currentUrl = {
          valueFi: '/fi/' + this.globals.toKebabCase(this.parent.name.valueFi) + '/' + this.globals.toKebabCase(this.organisation?.name?.valueFi) + '/' + this.educationTypeId + '/' + this.organisation?.id + '?period=' + this.period, 
          valueEn: '/en/' + this.globals.toKebabCase(this.parent.name.valueEn) + '/' + this.globals.toKebabCase(this.organisation?.name?.valueEn) + '/' + this.educationTypeId + '/' + this.organisation?.id + '?period=' + this.period,
          valueSv: '/sv/' + this.globals.toKebabCase(this.parent.name.valueEn) + '/' + this.globals.toKebabCase(this.organisation?.name?.valueEn) + '/' + this.educationTypeId + '/' + this.organisation?.id + '?period=' + this.period
        };
        //console.log(this.globals.currentUrl);
      }
    } else {
      //
      //uniarts only
      this.globals.currentUrl = {
          valueFi: '/fi/' + this.globals.toKebabCase(this.organisation?.name?.valueFi) + '/' + this.organisation?.id + '/e' , 
          valueEn: '/en/' + this.globals.toKebabCase(this.organisation?.name?.valueEn) + '/' + this.organisation?.id + '/e' ,
          valueSv: '/sv/' + this.globals.toKebabCase(this.organisation?.name?.valueEn) + '/' + this.organisation?.id + '/e' 
        };

    }

    this.globals.createLinkForCanonicalURL();
  }




}


